import React from 'react';
import { Segment, Grid, Button } from "semantic-ui-react";

const Terms = (props) => {
  return (
    <Grid.Column>
      <Segment className={"terms " + (props.visibleTerms ? 'visible' : '')}>
        <p className="mb-3">Terms of Use</p>
        <p>By accessing the wireless network, you acknowledge that you're of legal age, you have read and understood and agree to be bound by this agreement.</p>
        <p>The wireless network service is provided by the property owners and is completely at their discretion. Your access to the network may be blocked, suspended or terminated at any time for any reason.</p>
        <p>You agree not to use the wireless network for any purpose that is unlawful and take full responsibility of your acts.</p>
        <p>The wireless network is provided "as is" without warranties of any kind, either expressed or implied.</p>

        <div className="ui column vertical ui segment right aligned">
          <Button className="ui secondary button medium" onClick={props.onClickReturn}>
            Return
          </Button>
        </div>
      </Segment>
    </Grid.Column>
  )

}

export default Terms;


// WEBPACK FOOTER //
// ./src/components/hotspot/home/terms/Terms.js